import * as FW from 'fw/system/FW'
import * as API from 'modules/app/API'
import * as Context from 'fw/system/Context'
import * as Logging from 'fw/system/Logging'
import packageJson from '../../../package.json'
import moment from 'moment'

export const start = () => {
    // Initialize API pointing to the right URL
    FW.initialize({
        dateFormat: "DD MMM YYYY",
        timeFormat: "hh:mm:ss A",
        loginRoute: "/public/login",
        fileUploadUrl: API.App.url('/storage/upload'),
        fileUploadEncryptedUrl: API.App.url('/storage/uploadEncrypted'),
        fileDownloadUrl: API.App.url('/storage/directDownload'),
        fileDownloadEncryptedUrl: API.App.url('/storage/download'),
		fileViewUrl: API.App.url('/storage/directView?p='),
		loggingUrl: API.App.url('/logging/log'),
        version: packageJson.version,
        showNews: true
    });

    // Remove unwanted warnings
    removeWarnings();

    // Hook error global catcher
    hookGlobalErrorCatcher();
}

export const context = () => {
    return Context.retrieve();
}

export const login = (r) => {
    Context.store(r);
}

export const updateUserName = (userName) => {
    Context.set("userName", userName);
}

export const updateAuditUserName = (auditUserName) => {
    Context.set("auditUserName", auditUserName);
}

export const updatePasswordExpirationRemainingDays = (passwordExpirationRemainingDays) => {
    Context.set("passwordExpirationRemainingDays", passwordExpirationRemainingDays);
}

export const updateLastSetupTabIsSingle = (lastSetupTabIsSingle) => {
    Context.set("lastSetupTabIsSingle", lastSetupTabIsSingle);
}

export const updateSearchQueueFilters = (filters) => {
    Context.set("searchQueueFilters", filters);
}

export const logout = () => {
    Context.clear();
}

export const isAuthenticated = () => {
    if (Context.retrieve() == null)
        return false;

    var sessionTimeout = Context.get("sessionTimeout");
    var lastServerCall = Context.get("lastServerCall");
    var diff = moment().diff(lastServerCall, 'minutes');

    // If last server call was too long ago
    if (diff > sessionTimeout)
    {
        logout();
        return false;
    }
    
    return true;
}

export const revertImpersonation = () => {
    API.Security.post('/authentication/revertImpersonation', null,
        {
            success: (sr) => {
                login(sr.data);
                window.location.href = "/";
            }
        });
}

export const impersonate = (userId) => {
    const rq = {
        userId: userId
    };

    API.Security.post('/authentication/impersonate', rq,
        {
            success: (sr) => {
                login(sr.data);
                window.location.href = "/";
            }
        });
}

export const hasPrivilege = (privilegeCode) => {
    const privileges = Context.get("privileges");

    if (privileges === null)
        return false;

    return privileges.includes(privilegeCode);
}

export const getAvatar = (userId) => {
    return API.Security.url('/query/getAvatar?userId=') + userId;
}

const removeWarnings = () => {
    // Remove react-data-grid warnings
    const warning = "Warning: getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.";
    const consoleError = console.error.bind(console);

    console.error = (...args) => {
        if (args[0] === warning) return;
        return consoleError(...args);
    };
}

const hookGlobalErrorCatcher = () => {
    // Catch-all errors
    window.onerror = function (msg, url, lineNo, columnNo, error) {
        const message = [
            'Message: ' + msg,
            'URL: ' + url,
            'Line: ' + lineNo,
            'Column: ' + columnNo,
            'Error object: ' + JSON.stringify(error)
        ].join(' - ');
        
        Logging.log(message);

        return false;
    };
}


// WEBPACK FOOTER //
// ./src/modules/app/App.js